import ReactProfilingMode, {type ProfilingDecisionSource} from '@github-ui/react-profiling-mode'

/**
 * Determines if React Profiler should be enabled for this user session.
 *
 * Delegates to ReactProfilingMode which handles:
 * - The server's per-request decision (via the `react-profiling` meta tag) when present
 * - Otherwise a client fallback: staff enabled by default, production users at 2% (session-stable)
 *
 * @returns true if profiling should be enabled, false otherwise
 */
export function isReactProfilerEnabled(): boolean {
  return ReactProfilingMode.isEnabled()
}

/**
 * Resets the cached enablement decision.
 * Only intended for testing purposes.
 */
export function resetProfilerEnabledCache(): void {
  ReactProfilingMode.resetCache()
}

/**
 * Whether the profiling decision came from the server (which also swapped the react-dom build via
 * the import map) or from the client-side fallback audience (where no swap happened, so the timings
 * come from the STANDARD build). Emitted as a metric tag so the two populations stay separable.
 */
export function reactProfilerDecisionSource(): ProfilingDecisionSource {
  return ReactProfilingMode.getDecisionSource()
}
